import { Box, Icon, Link, Text } from '@nimbus-ds/components';
import { ChevronRightIcon } from '@nimbus-ds/icons';
import { IconBox } from 'commons/components';
import { DiscountOption } from './types';

interface DiscountOptionRowProps extends DiscountOption {
  isLastOption: boolean;
}

export function DiscountOptionRow({
  title,
  description,
  onClick,
  icon,
  isLastOption,
}: Readonly<DiscountOptionRowProps>): JSX.Element {
  const IconComponent = icon;

  return (
    <Box
      display="grid"
      gridTemplateColumns={{ xs: '15fr 70fr 15fr', md: '9fr 84fr 7fr' }}
      alignItems="center"
      paddingTop="2-5"
      paddingBottom="2-5"
      paddingLeft="1"
      paddingRight="1"
      borderStyle="solid"
      borderColor="neutral-surfaceHighlight"
      borderWidth="1"
      borderBottomWidth={isLastOption ? '1' : 'none'}
    >
      <Box display="flex" justifyContent="center" alignItems="center">
        <IconBox
          color="primary-interactive"
          backgroundColor="primary-surface"
          height="28px"
          width="28px"
          minWidth="28px"
          borderRadius="half"
        >
          <Icon color="primary-textLow" source={<IconComponent size={16} />} />
        </IconBox>
      </Box>

      <Box display="flex" flexDirection="column" justifyContent="center">
        <Text fontSize="base" color="neutral-textHigh">
          {title}
        </Text>
        <Text>{description}</Text>
      </Box>

      <Box display="flex" justifyContent="center" alignItems="center">
        <Link
          onClick={onClick}
          appearance="primary"
          textDecoration="none"
          fontSize="highlight"
          lineHeight="highlight"
        >
          <ChevronRightIcon />
        </Link>
      </Box>
    </Box>
  );
}
